import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';

interface ProfilePictureAvatarProps extends Omit<AvatarProps, 'src'> {
  filename: string;
}

const ProfilePictureAvatar: React.FC<ProfilePictureAvatarProps> = ({ 
  filename, 
  ...avatarProps 
}) => {
  // Use direct URL approach instead of blob
  const imageUrl = `${localStorage.getItem('useRemoteApi') === 'true' 
    ? process.env.REACT_APP_REMOTE_API_URL 
    : process.env.REACT_APP_LOCAL_API_URL}/api/admin/mock/profile-picture/${filename}`;
  
  console.log('ProfilePictureAvatar loading:', imageUrl);
  
  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error('Image failed to load:', imageUrl, e);
  };
  
  const handleLoad = () => {
    console.log('Image loaded successfully:', imageUrl);
  };
  
  return (
    <Avatar 
      {...avatarProps} 
      src={imageUrl}
      imgProps={{
        onError: handleError,
        onLoad: handleLoad
      }}
    />
  );
};

export default ProfilePictureAvatar; 